<template lang="pug"></template>

<script>
export default {
    name: 'BotaoMonitoramentoSocioambiental',
    componentOptions: {
        title: 'Monitoramento',
        actions: [
            [
                {
                    name: 'Monitoramento Socioambiental',
                    iconClass: 'lyra-icon lyra-arvore',
                    showView: false,
                    action: 'abrirMonitoramento',
                    route: 'MonitoramentoSocioambiental'
                }
            ]
        ]
    },

    methods: {
        abrirMonitoramento() {
            if (this.$route.name !== 'MonitoramentoSocioambiental') {
                this.$router.push({
                    name: 'MonitoramentoSocioambiental',
                    params: { periodoAlerta: null }
                });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
